"use client";

import { c as _c } from "react/compiler-runtime";
import type { FooterFragmentResult } from "@/lib/sanity/sanity.types";
import { useAudience } from "@/components/common/audience";
import { FooterMenu } from "./footer-menu.component";
type FooterData = NonNullable<FooterFragmentResult>;
interface FooterMenusByAudienceProps {
  menus: FooterData["menus"];
  businessMenus: FooterData["businessMenus"];
}

/**
 * Desktop footer menu columns. Swaps between visitor and business menu sets
 * based on the active audience toggle. Kept as a small client island so the
 * rest of the footer stays a server component.
 */
export function FooterMenusByAudience(t0) {
  const $ = _c(4);
  const {
    menus,
    businessMenus
  } = t0;
  const {
    activeTab
  } = useAudience();
  const activeMenus = activeTab === "businesses" ? businessMenus : menus;
  if (!activeMenus || activeMenus.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== activeMenus) {
    t1 = activeMenus.map(_temp);
    $[0] = activeMenus;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="col-span-4 desktop:col-span-6 desktop:col-start-6"><div className="columns-2 gap-6 desktop:columns-3">{t1}</div></div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(menu) {
  return menu ? <div key={menu.id} className="mb-10 break-inside-avoid"><FooterMenu heading={menu.heading} items={menu.items} /></div> : null;
}